<template>
    <li class="h-5 justify-start items-start gap-3 flex cursor-pointer">
        <div class="py-0.5 justify-start items-center gap-2.5 flex">
            <input
                type="checkbox"
                class="py-0.5 justify-start items-center flex text-orange-600 w-4 h-4 bg-white dark:bg-slate-700 rounded border border-slate-300 dark:border-slate-600 focus:ring-0 focus:outline-none cursor-pointer"
                :id="option[valueKey]"
                :name="option[labelKey]"
                :checked="checked"
                @change="toggleSelect(option)"
            />
        </div>
        <div class="justify-center items-center gap-2 flex h-full">
            <Icon :icon="icon" v-if="icon" />
            <label
                :for="option[valueKey]"
                :class="labelClass + ' cursor-pointer'"
            >
                <p class="align-center">{{ option[labelKey] }}</p>
            </label>
        </div>
    </li>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    icon: {
        type: String,
        default: null,
    },
    option: {
        type: Object,
        required: true,
    },
    checked: {
        type: Boolean,
        default: false,
    },
    labelKey: {
        type: String,
        default: 'label',
    },
    valueKey: {
        type: String,
        default: 'value',
    },
    labelClass: {
        type: String,
        default: 'text-slate-800 dark:text-slate-100 dark:text-slate-200 text-sm font-normal leading-tight',
    },
});

const emit = defineEmits(['toggleSelect']);

const toggleSelect = () => {
    emit('toggleSelect', props.option);
};
</script>
